import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import { LuUserPlus } from "react-icons/lu";
import { BsTrash3 } from "react-icons/bs";
/*import { LuEdit2 } from "react-icons/lu"*/
import { TbCheckbox } from "react-icons/tb";
import { RiCheckboxBlankLine } from "react-icons/ri";

import { useDispatch, useSelector } from "react-redux"; //this import redux functions
import { Link } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ImageCard from "../cards/ImageCard";

const CaseAssignedBySideBar = ({
  setShowSideBar,
  case_cd,
  accessBy,
  setAccessBy,
  officeAttornyTeam,
}) => {
  const [areasMode, setAreasMode] = useState("List");
  const [viewMode, setViewMode] = useState("");
  const [clientDetails, setClientDetails] = useState({});
  const [branchUsers, setBranchUsers] = useState([]);
  useEffect(() => {
    if (setShowSideBar) {
      document.getElementById("caseAssignedBySideBar").style.width = "23%";
    }
  }, [setShowSideBar]);

  const closeNav = () => {
    document.getElementById("caseAssignedBySideBar").style.width = "0";
    setTimeout(() => {
      setShowSideBar(false);
    }, 300);
  };

  const set_clear_mode = () => {
    setClientDetails({});
    switch (areasMode) {
      case "Edit":
        setAreasMode("List");
        break;
      case "View":
        setAreasMode("Edit");
        break;
      default:
    }
  };

  const not_exist_in_acces_by = (office_user) => {
    console.log("user = ", office_user);
  };

  /* Read ----------------------*/

  /* update -------------------------*/
  const update_acces_by = async (
    attorny_user_cd,
    update_function,
    officeAttornyTeam,
  ) => {
    try {
      let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
      const data = {
        info: {
          lang: userDataLocal.lang,
          company: userDataLocal.company_cd,
          user_cd: userDataLocal.user_cd,
        },
        input: {
          actioncode: "update_case_acces_by",
          case_cd: case_cd,
          attorny_user_cd: attorny_user_cd,
          update_function: update_function,
        },
      };
      console.log("update_case_acces_by input ", data);

      let res = await axios.post(
        `${process.env.REACT_APP_BACK_END_URL}/api/lcc/update_case_acces_by`,

        data,
        {
          headers: {
            Authorization: `Bearer ${userDataLocal.token}`,
          },
        },
      );

      console.log("update_case_acces_by output ", res);

      if (res.data.output.case_accessed_by.length > 0) {
        setAccessBy([]);
        setAccessBy(res.data.output.case_accessed_by);
      }
      setAreasMode("Edit");
    } catch (err) {
      console.log(err);
      alert("error message" + err.message);
    }
  };

  return (
    <>
      <div
        id="caseAssignedBySideBar"
        class="sidenav border-box-right-sidebar"
        style={{ padding: "80px 10px 10px 10px" }}
      >
        <div
          class="closebtn"
          style={{ top: "30px", right: "20px" }}
          onClick={closeNav}
        >
          ×
        </div>

        <div>
          <div style={{ height: "36px" }}>
            <div className="normal_float normal_text_align ">
              {(areasMode === "View" || areasMode === "Edit") && (
                <>
                  <Tooltip title="Back" placement="bottom" arrow>
                    <IconButton
                      onClick={() => {
                        set_clear_mode();
                      }}
                    >
                      <ArrowBackIcon color="inherit" fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <span className="separator_border">
                    {" " + clientDetails && clientDetails.client_cd}
                  </span>
                </>
              )}
            </div>
            <div className="opposite_float opposite_text_align">
              {areasMode === "List" && (
                <>
                  <Tooltip title="Edit" placement="bottom" arrow>
                    <IconButton
                      onClick={() => {
                        setAreasMode("Edit");
                      }}
                    >
                      <ModeOutlinedIcon color="inherit" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              {areasMode === "View" && (
                <>
                  {viewMode === "insert" && (
                    <>
                      <Tooltip title="add New" placement="bottom" arrow>
                        <IconButton
                          onClick={() => {
                            update_acces_by("insert");
                          }}
                        >
                          <LuUserPlus color="inherit" size={18} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {viewMode === "delete" && (
                    <>
                      <Tooltip title="add New" placement="bottom" arrow>
                        <IconButton
                          onClick={() => {
                            update_acces_by("delete");
                          }}
                        >
                          <BsTrash3 color="inherit" size={18} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              )}
            </div>
            <div style={{ clear: "both" }}></div>
          </div>

          {/*case clients list area*/}
          {(areasMode === "List" || areasMode === "Edit") && (
            <>
              {accessBy.length > 0 &&
                accessBy.map((access_by, index) => (
                  <div className="row_area" key={access_by.user_cd + index}>
                    <div>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            width: "24px",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            update_acces_by(access_by.user_cd, "delete");
                          }}
                        >
                          {areasMode === "Edit" && <TbCheckbox size="20" />}
                        </div>
                        <div className="user_line">
                          <div className="user_line_area">
                            <div style={{ display: "flex" }}>
                              <div>
                                <img
                                  src={
                                    "https://files.amanrow.com/user/" +
                                    access_by.image_name
                                  }
                                  alt=" "
                                  className="user_profile_image"
                                />
                              </div>
                              <div
                                className="space-betw-vertical"
                                style={{ margin: "0px 10px" }}
                              >
                                <div> {access_by.full_name}</div>
                                <div>{access_by.job_title}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              <div>-----------------------------------------------------</div>
              {areasMode === "Edit" && (
                <>
                  {officeAttornyTeam.length > 0 &&
                    officeAttornyTeam.map((branch_users, index) => (
                      <div
                        className="row_area"
                        key={branch_users.user_cd + index}
                      >
                        <div>
                          <div style={{ display: "flex" }}>
                            <div
                              style={{
                                width: "24px",
                                display: "flex",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                update_acces_by(branch_users.user_cd, "insert");
                              }}
                            >
                              {areasMode === "Edit" && (
                                <RiCheckboxBlankLine size="20" />
                              )}
                            </div>
                            <div className="user_line">
                              <div className="user_line_area">
                                <div style={{ display: "flex" }}>
                                  <div>
                                    <img
                                      src={
                                        "https://files.amanrow.com/user/" +
                                        branch_users.image_name
                                      }
                                      alt=" "
                                      className="user_profile_image"
                                    />
                                  </div>
                                  <div
                                    className="space-betw-vertical"
                                    style={{ margin: "0px 10px" }}
                                  >
                                    <div> {branch_users.full_name}</div>
                                    <div>{branch_users.job_title}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CaseAssignedBySideBar;
